import React, { Component } from 'react'

export default class SubsidiaryCard extends Component {

  render () {

    const { item } = this.props;

    let divisor = ( (item && item.name === 'Sucursal Puertos Escobar') ? '' : "bar-divisor sucursal");
    const name = item.name === 'sanisidro' ? 
      'San Isidro' : item.name.charAt(0).toUpperCase() + item.name.slice(1)

    return (
    	<div className="item-sucursal">
        { (item) ? (
          <div>
            <h1>{name}</h1>
            <div className="items-align">
              <i className="fa fa-map-marker"></i>
              <h3>{item.address}</h3>  
            </div>
            <div className="items-align">
                    <i className="fa fa-mobile"></i>
                    <h3>({item.code}) - {item.telefono.replace(/(\d{4})(\d{4})/, "$1-$2")}</h3>
            </div>
            <div className={divisor}></div></div>) : '' }
    	</div> 
    )
  }
}


// WEBPACK FOOTER //
// ./src/features/PageCompany/Components/Subsidiaries/cardItem.js